import React from 'react'
import DatePicker from '../../UI/DatePicker/DatePicker'
import Button from '../../UI/Button/Button'
import ContentForm from '../../UI/ContentForm/ContentForm'
import Fade from 'react-reveal/Fade'
import Add from '@material-ui/icons/Add'
import './CalendarZoneDateForm.css'
import FetchData from '../../../shared/fetchData'
import Remove from '@material-ui/icons/Remove'
import ReactPaginate from 'react-paginate'
import Spinner from '../../UI/Spinner/Spinner'

const CalendarZoneDateForm = (props) => {

    const [calendarZoneId, setCalendarZoneId] = React.useState(props.calendarZoneId)
    const [loading, setLoading] = React.useState(false)
    const [dates, setDates] = React.useState([])
    const [date, setDate] = React.useState('')
    const [changeForm, setChangeForm] = React.useState(false)
    const [offset, setOffset] = React.useState(1)
    const [perPage, setPerPage] = React.useState(5)
    const [pageCount, setPageCount] = React.useState(0)

    React.useEffect(() => {
        var raw = JSON.stringify({
            "calendarZone": {
                "id": calendarZoneId,
            },
            "pl": perPage,
            "pn": offset,
            "version": "mtpx001"
        })

        var url = 'management/api/v1/calendarzones/getCalendarZoneDates'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    const dts = []
                    result.calendars.map(c => {
                        dts.push(c.date)
                    })
                    setDates(dts)
                    setPageCount(result.count / parseInt(perPage))
                }
            })
            .catch(error => setLoading(false))
    }, [])


    const handlePageClick = (e) => {
        setOffset(e.selected + 1)
        var raw = JSON.stringify({
            "calendarZone": {
                "id": calendarZoneId,
            },
            "pl": perPage,
            "pn": e.selected + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/calendarzones/getCalendarZoneDates'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    const dts = []
                    result.calendars.map(c => {
                        dts.push(c.date)
                    })
                    setDates(dts)
                    setPageCount(result.count / parseInt(perPage))
                }
            })
            .catch(error => setLoading(false))
    }

    const calendarZoneDateSubmit = (event) => {
        setLoading(true)
        let valid = true
        if (dates == null || dates.length == 0) {
            valid = false
        }
        if (valid) {
            const dts = []
            for (let key in dates) {
                dts.push({ "date": dates[key] })
            }
            var raw = JSON.stringify({
                "calendarZone": {
                    "id": calendarZoneId,
                    "calendars": dts
                },
                "version": "mtpx001"
            })

            var url = 'management/api/v1/calendarzones/updateCalendarZoneDates'
            FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == 0) {
                        props.toggleAssignDate(event, false)
                    }
                })
                .catch(error => setLoading(false))
        }
    }
    const addDate = (event) => {
        if (date != '') {
            dates.push(date)
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
        }
    }
    const removeDate = (event, date) => {
        const dts = dates.filter(d => d != date)
        setDates(dts)
    }

    const changeDate = (unix, formatted) => {
        setDate(formatted)
    }

    const dts = dates != null && dates.length != 0 ?
        dates.map(d => {
            return (
                <div className='row justify-content-center w-100 mt-2'>
                    <div className='dt'>
                        <div className='row justify-content-center w-100 mt-2'>
                            <div className='col-10 text-center'>
                                {d}
                            </div>
                            <div className='col-2 mb-1'>
                                <Remove className="ksk-lck-tp-icon" onClick={(event) => removeDate(event, d)} />
                            </div>
                        </div>
                    </div>
                </div>
            )
        }) :
        <div className='row justify-content-center w-100 mt-2'>
            <div className='dt'>
                لیست تاریخ خالی است
            </div>
        </div>
    return (
        <Fade duration={200} left cascade>
            {loading ? <Spinner /> : ''}
            <div>
                <div className='row justify-content-center'>
                    <div className='clndr-zn-cntnr'>
                        <ContentForm headetText='تاریخ'>
                            <div className="row justify-content-center w-100">
                                {dts}
                            </div>
                            {dts != null && dts.length != 0 ?
                                <div className="row justify-content-center w-100">
                                    <ReactPaginate
                                        previousLabel={"→قبلی"}
                                        nextLabel={"بعدی←"}
                                        forcePage={offset >= 0 ? offset - 1 : offset}
                                        breakLabel={"..."}
                                        breakClassName={"break-me"}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={1}
                                        onPageChange={handlePageClick}
                                        containerClassName="pagination"
                                        subContainerClassName={"pages pagination"}
                                        activeClassName={"active"} />
                                </div>
                                : ''}
                            <div className='clndr-zn-frm'>
                                <DatePicker change={changeDate} col="10 mt-3 hulf-small" value={date} placeHolder="تاریخ"></DatePicker>
                                <div className='col-2 mt-3 hulf-small'>
                                    <Add className="UserIcon" onClick={addDate} />
                                </div>
                            </div>
                            <div className='row justify-content-center w-100 mt-3'>
                                <div className='col-6 text-center'>
                                    <Button btnType="General" clicked={(event) => props.toggleAssignDate(event, false)}>برگشت</Button>
                                </div>
                                <div className='col-6 text-center'>
                                    <Button btnType="Success" clicked={calendarZoneDateSubmit}>ثبت</Button>
                                </div>
                            </div>
                        </ContentForm>
                    </div>
                </div>
            </div>
        </Fade>
    )
}

export default CalendarZoneDateForm